import React from 'react';

const Notfound = () => {
    return (
        <div>
            <h1>404 Page not Found!</h1>
        </div>
    );
};

export default Notfound;